import styled from '@emotion/styled'
import { Chip, Tab, Tabs, Typography } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

export const StyledTabs = styled(Tabs)`
    margin-bottom: ${getPxAsRem(12)};
`
export const ContactChip = styled(Chip)``

export const StyledCard = styled.div`
    padding: ${getPxAsRem(20)};
    border-radius: ${getPxAsRem(8)};
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
    overflow: auto;
    height: ${getPxAsRem(270)};
    background-color: ${({ theme }) => theme.palette.greyscale.white};
`

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${getPxAsRem(20)};
`

export const ContactRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: ${getPxAsRem(8, 0)};
    width: 100%;
`

export const ContactDetails = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex-direction: row;
    margin-bottom: ${getPxAsRem(8)};
`

export const ContactEmailPhone = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    gap: ${getPxAsRem(4)};
`

export const InfoText = styled(Typography)`
    white-space: nowrap;
    overflow: hidden;
    margin-top: ${getPxAsRem(2)};
    text-overflow: ellipsis;
    min-width: 0;

    @media (max-width: 768px) {
        margin-right: 0;
        margin-bottom: ${getPxAsRem(8)};
    }
`

export const StyledTab = styled(Tab)`
    flex: 1;
    min-width: 0;
    text-align: center;
    white-space: nowrap;
    font-size: ${getPxAsRem(12)};
`
export const StyledWrapTab = styled(Tab)`
    flex: 1;
    min-width: 0;
    text-align: center;
    white-space: wrap;
    font-size: ${getPxAsRem(12)};
`

export const MobileContactRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${getPxAsRem(8, 0)};
`

export const IconContainer = styled.div`
    display: flex;
    gap: ${getPxAsRem(24)};
`
